import { makeAutoObservable } from 'mobx';
import { EquipmentConfiguration, createEquipmentConfiguration } from './EquipmentConfiguration';

export type ProgramParams = {
  tags: string[];
  equipmentConfiguration: EquipmentConfiguration;
  setSingleTag(tag: string): void;
  removeTagGroup(tagGroup: string): void;
};

export function createProgramParams(json?: Partial<ProgramParams>): ProgramParams {
  return makeAutoObservable({
    tags: json?.tags ?? [],
    equipmentConfiguration: createEquipmentConfiguration(json?.equipmentConfiguration),

    setSingleTag(tag: string) {
      const index = tag.indexOf(':');
      if (index !== -1) {
        const group = tag.substring(0, index);
        this.tags = this.tags.filter((t) => !t.startsWith(`${group}:`));
        this.tags.push(tag);
      }
    },

    removeTagGroup(tagGroup: string) {
      this.tags = this.tags.filter((t) => !t.startsWith(`${tagGroup}:`));
    },
  });
}
